<template>
  <el-container class="login">
    <el-header>
      <el-row>
        <el-col :span="8">
          <img class="logo" :src="$globalConfig.logo" alt="">
          <div class="title">{{$globalConfig.title}}</div>
        </el-col>
      </el-row>
    </el-header>
    <el-main>
      <el-row>
        <el-col :span="14" class="col-left">
          <img class="login-img" src="/static/img/bg/bg_login_left.png" alt="">
        </el-col>
        <el-col :span="10" class="col-right">
          <div class="form-title">用户登录</div>
          <div class="form-wrap">
            <el-form :model="loginForm" ref="loginForm" :rules="rules">
              <el-form-item prop="name">
                <el-input v-model="loginForm.name" placeholder="请输入用户名" clearable>
                  <i slot="prefix" class="el-input__icon el-icon-username"></i>
                </el-input>
              </el-form-item>
              <el-form-item prop="password" v-if="this.$globalConfig.loginMode === 0">
                <el-input v-model="loginForm.password" type="password" placeholder="请输入密码" clearable>
                  <i slot="prefix" class="el-input__icon el-icon-password"></i>
                </el-input>
              </el-form-item>
              <el-form-item prop="verificationCode" v-if="this.$globalConfig.loginMode === 1">
                <el-input v-model="loginForm.verificationCode" placeholder="请输入6位短信验证码">
                  <i slot="prefix" class="el-input__icon el-icon-password"></i>
                  <el-button style="height:40px;padding-right:10px" slot="suffix" type="text" @click="sendSmsVerificationCode('loginForm')">{{sendSmsVerificationCodeButtonText}}</el-button>
                </el-input>
              </el-form-item>
              <el-checkbox v-model="rememberPassword" style="margin:0px 0px 30px 0px;" v-if="this.$globalConfig.loginMode === 0">记住密码</el-checkbox>
              <div style="height:30px;" v-else></div>
              <el-form-item>
                <el-button type="primary" class="login-button" @click="submitForm('loginForm')">登&nbsp;&nbsp;录</el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-col>
      </el-row>
    </el-main>
  </el-container>
</template>

<script type="text/ecmascript-6">
import Login from './Login.js'
export default Login
</script>

<style lang="scss" >
@import "Login.scss";
</style>



// WEBPACK FOOTER //
// src/views/login/Login.vue